<div class="files-section" #filesEl>
  <div class="file-item d-flex flex-column align-items-center" *ngFor="let file of files">
    <div class="remove" (click)="onRemove(file.id); $event.stopPropagation(); false">
      <svg viewBox="0 0 26 26">
        <use href="#cancel" />
      </svg>
    </div>
    <div class="icon">
      <svg viewBox="0 0 60 60">
        <use href="#new-file" />
      </svg>
    </div>
    <div class="file-name" [matTooltip]="file.name"
      >{{ { name: file.name | textTruncate: 15 , mime: file.mime } | mimeToExtension }}</div
    >

    <a [href]="file.url | baseUrl" target="_blank" class="link">Download</a>
  </div>
</div>
